import { createConsumer } from "@rails/actioncable"

const consumer = createConsumer()

export { consumer }
export { default as ChatRoomChannel } from "./chat_room_channel"
export { default as NotificationChannel } from "./notification_channel"
